import React, {Component} from 'react';

export function ErrorPanel({error}) {
    return (
        <div style={{backgroundColor: 'red', color: 'white'}}>
            {error.toString()}
        </div>
    );
}

class ErrorBoundary extends Component {
    state = {error: null, info: null};

    componentDidCatch(error) {
        this.setState({error});
        // TODO log error with knotty
    }

    render() {
        const {children, Fallback} = this.props;
        const {error} = this.state;
        if (error !== null) {
            return <Fallback error={error} />;
        }
        return children;
    }
}

export function withErrorBoundary(
    children,
    Fallback = process.env.NODE_ENV === 'production' ? 'span' : ErrorPanel
) {
    return (
        <ErrorBoundary Fallback={Fallback}>
            {children}
        </ErrorBoundary>
    );
}
